// extracted by mini-css-extract-plugin
export default {"title":"Certificates_title__mf0IC","desktop":"Certificates_desktop__QUbxa","desktop__content":"Certificates_desktop__content__JJ5FA"};